import { Link } from 'react-router-dom'

// Shown when a sync is BLOCKED because a party has no BoxTop account code. Nothing was sent to BoxTop. Each company links straight to
// its page so the code can be added there; then sync again. Master-level (MBL) parties are independent of the customer, so they are
// never placed under the customer's account instead.
export interface MissingAccountParty { role: string; label: string; customerId: string; customerName: string; independent: boolean }

interface Props { jobRef: string; parties: MissingAccountParty[]; onClose: () => void }

export default function MissingBoxtopAccountDialog({ jobRef, parties, onClose }: Props) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4" onClick={onClose}>
      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-xl w-full max-w-lg p-6" onClick={e => e.stopPropagation()}>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-white mb-1">Not synced — BoxTop code missing ({jobRef})</h2>
        <p className="text-sm text-gray-600 dark:text-gray-300 mb-3">Nothing was sent to BoxTop. These companies have no BoxTop account code:</p>
        <ul className="space-y-2 mb-4">
          {parties.map(p => (
            <li key={p.role} className="border border-red-200 dark:border-red-700 bg-red-50 dark:bg-red-900/20 rounded-lg px-3 py-2 text-sm text-red-800 dark:text-red-300 flex items-center justify-between gap-3">
              <span><strong>{p.label}:</strong> {p.customerName}{p.independent ? <span className="block text-xs">Master-level party — independent of the customer, needs its own code.</span> : null}</span>
              <Link to={`/customers/${p.customerId}`} target="_blank" className="shrink-0 px-2 py-1 rounded border border-red-300 text-red-700 hover:bg-red-100 text-xs font-medium">Add BoxTop code →</Link>
            </li>
          ))}
        </ul>
        <p className="text-xs text-gray-500 dark:text-gray-400 mb-4">Open each company, fill in "BoxTop account" (use Verify to check it exists in BoxTop), then come back and sync again. The customer's own account is never used as a substitute.</p>
        <div className="flex justify-end"><button onClick={onClose} className="px-4 py-2 text-sm rounded-lg bg-gray-100 hover:bg-gray-200 dark:bg-gray-700 dark:hover:bg-gray-600 text-gray-800 dark:text-gray-100">Close</button></div>
      </div>
    </div>
  )
}
